import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StatusChipComponent } from './status-chip.component';

@NgModule({
  declarations: [StatusChipComponent],
  imports: [CommonModule],
  exports: [StatusChipComponent]
})
export class StatusChipModule {}
